import React from "react";
// Nodejs library that concatenates classes
import classNames from "classnames";
// Nodejs library to set properties for components
import PropTypes from "prop-types";

// Material-ui components
import withStyles from "@material-ui/core/styles/withStyles";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
// Core components
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardHeader from "components/Card/CardHeader.jsx";

import IconButton from "@material-ui/core/IconButton";

import customTabsStyle from "assets/jss/material-dashboard-pro-react/components/customTabsStyle.jsx";

class CustomTabs extends React.Component {

    constructor (props) {

        super(props);
        this.changeTabCallBack = this.changeTabCallBack.bind(this);

    }

  state = {
      "value":
      this.props.value &&
      Number.isInteger(this.props.value) &&
      this.props.value >= 0 &&
      this.props.value < this.props.tabs.length
          ? this.props.value
          : 0
  };

  handleChange = (event, value) => {

      this.setState({value});
      this.changeTabCallBack(value);

  };

  changeTabCallBack (value) {

      this.props.changeTabCallBack(value);

  }

  componentWillReceiveProps(props) {
    if (props.value !== this.state.value) {
        this.setState({"value" : props.value});
    }
  }

  render () {

      const {
              classes,
              headerColor,
              plainTabs,
              tabs,
              title,
              rtlActive,
              marginBottom,
              bodyStyle,
              headerStyle,
              boxStyle,
              headerId
          } = this.props,
          cardTitle = classNames({
              [classes.cardTitle]: true,
              [classes.cardTitleRTL]: rtlActive
          });
      return (
          <Card style={{marginBottom: marginBottom, ...(boxStyle ? boxStyle : {})}} plain={plainTabs}>
              <CardHeader
                  style={headerStyle}
                  color={headerColor}
                  plain={plainTabs}
              >
                  {title !== undefined
                      ? <div className={cardTitle}>
                          {title}
                      </div>
                      : null}
                  <Tabs
                      id={headerId ? headerId : null}
                      classes={{
                          "root": classes.tabsRoot,
                          "indicator": classes.displayNone
                      }}
                      onChange={this.handleChange}
                      value={this.state.value}
                      variant="scrollable"
                      ScrollButtonComponent={(props) => {
                        if (props.direction === "left" && !props.disabled) {
                            return (
                                <IconButton {...props}>
                                    <i className="fas fa-angle-left"></i>
                                </IconButton>
                            );
                        } else if (props.direction === "right" && !props.disabled) {
                            return (
                                <IconButton {...props}>
                                    <i className="fas fa-angle-right"></i>
                                </IconButton>
                            );
                        } else {
                            return null;
                        }
                    }}
                  >
                      {tabs.map((prop, key) => {

                          let icon = {};
                          if (prop.tabIcon) {

                              icon = {
                                  "icon": <prop.tabIcon />
                              };

                          }
                          return (
                              <Tab
                                  classes={{
                                      "root": classes.tabRootButton,
                                      "selected": classes.tabSelected,
                                      "wrapper": classes.tabWrapper
                                  }}
                                  disabled={prop.tabDisabled ? true : false}
                                  key={key}
                                  label={prop.tabName}
                                  {...icon}
                                  style={prop.tabStyle}
                                  title={prop.hasOwnProperty('tabTitle') ? prop.tabTitle : ''}
                              />
                          );

                      })}
                  </Tabs>
              </CardHeader>
              <CardBody style={bodyStyle}>
                  {tabs.map((prop, key) => {

                      if (key === this.state.value) {

                          return (<div key={key}>
{prop.tabContent}
</div>);

                      }
                      return null;

                  })}
              </CardBody>
          </Card>
      );

  }

}

CustomTabs.propTypes = {
    "classes": PropTypes.object.isRequired,
    "headerColor": PropTypes.oneOf([
        "warning",
        "success",
        "danger",
        "info",
        "primary",
        "rose"
    ]),
    "title": PropTypes.string,
    "tabs": PropTypes.arrayOf(PropTypes.shape({
        "tabName": PropTypes.any.isRequired,
        "tabIcon": PropTypes.object,
        "tabContent": PropTypes.node.isRequired,
        "tabStyle": PropTypes.any,
        "tabDisabled": PropTypes.bool,
    })),
    "rtlActive": PropTypes.bool,
    "plainTabs": PropTypes.bool,
    "marginBottom": PropTypes.string,
    "bodyStyle": PropTypes.object,
    "headerStyle": PropTypes.object,
    "boxStyle": PropTypes.object,
    "headerId": PropTypes.string,
};

export default withStyles(customTabsStyle)(CustomTabs);
